<div class="full-view flex-centered background">
  <markant-spinner modal="false" type="bounce"></markant-spinner>
</div>
